import './ReasonIcon.scss'

import Tooltip from '../../core/Tooltip/Tooltip'
import { capitalize } from '../../../utilities/helpers'

const ReasonIcon = ({ reason, partialReceived, tooltipPosition = 'top' }) => {
    const iconsByReason = { unlock: 'lock_open', half: 'half_circle', medals: 'medal', check: 'eye' }
    
    return (
        <Tooltip text={partialReceived ? 'Second half' : capitalize(reason)} position={tooltipPosition}>
            <div className="reason-icon flex-center">
                <img src={`/images/icons/${partialReceived ? 'half_circle' : iconsByReason[reason]}.svg`} />
            </div>
        </Tooltip>
    )
}

export default ReasonIcon